import React, { useEffect, useState } from "react";

import "./stylesCustomDatePicker.css";

import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

function CustomDatePicker({ getData, dates, setDates, showPresets = false }) {
  const [open, setOpen] = useState(false);
  const [selectedPreset, setSelectedPreset] = useState("Today");

  const quickRanges = [
    { label: "Today", value: [dayjs(), dayjs()] },
    {
      label: "Yesterday",
      value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
    },
    {
      label: "This Week",
      value: [dayjs().startOf("week"), dayjs().endOf("week")],
    },
    {
      label: "Prior Week",
      value: [
        dayjs().subtract(1, "week").startOf("week"),
        dayjs().subtract(1, "week").endOf("week"),
      ],
    },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "Prior Month",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
  ];

  // Atualiza a classe 'selected' ao abrir o calendário
  useEffect(() => {
    const presetList = document.querySelector(".ant-picker-presets ul");
    if (presetList) {
      const listItems = presetList.querySelectorAll("li");
      listItems.forEach((li) => li.classList.remove("selected"));
      const selectedIndex = quickRanges.findIndex(
        (p) => p.label === selectedPreset
      );
      if (listItems[selectedIndex]) {
        listItems[selectedIndex].classList.add("selected");
      }
    }
  }, [selectedPreset, open]);

  return (
    <div className="custom-datepicker-container">
      <RangePicker
        value={dates}
        onChange={(values) => {
          setDates(values);
          setOpen(false);

          const matchedPreset = quickRanges.find(
            (preset) =>
              values[0].isSame(preset.value[0], "day") &&
              values[1].isSame(preset.value[1], "day")
          );

          if (matchedPreset) {
            setSelectedPreset(matchedPreset.label);
          }

          const queryString = `start_date=${values[0].format(
            "YYYY-MM-DD"
          )}&end_date=${values[1].format("YYYY-MM-DD")}`;
          getData(queryString);
        }}
        open={open}
        onOpenChange={setOpen}
        presets={showPresets ? quickRanges : []}
      />
    </div>
  );
}

export default CustomDatePicker;
